<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label='全部' name="all"></el-tab-pane>
      <el-tab-pane label='在库' name="inStock"></el-tab-pane>
      <el-tab-pane label='已发' name="sented"></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
       :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgId>
        <el-select multiple v-model="filters.orgId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in organizations"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseId>
        <el-select multiple v-model="filters.warehouseId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
         <template slot-scope="scope" slot="batchNum">
                  <el-link :underline="false" type="primary"
                          @click.native="batchesInventoryDetail(scope.row)">{{scope.row.batchNum}}
                  </el-link>
        </template>
    </TwTable>

    <LogDialog
      :logConfig="InOutDetailTableConfig"
      :showLog="showLogInOut"
      :requestData="{
        prosku:currentRow.sku,
        warehouseId:currentRow.warehouseID,
        ProductId:currentRow.productInfoID}"
      :requestApi="'/InventoryReport/GetInventoryDetailAsync'"
      :requestMethod="'post'"
      v-if="showLogInOut"
      @showDialog="showDialogInOut"
    ></LogDialog>

      <LogDialog
      :logConfig="batchesInventoryTableConfig"
      :showLog="showLog"
      v-if="showLog"
      :requestData="{
        prosku:currentRow.sku,
        warehouseId:currentRow.warehouseID,
        ProductId:currentRow.productInfoID}"
      :requestApi="'/InventoryReport/GetBatchesInventoryAsync'"
      :requestMethod="'post'"
      @showDialog="showDialog"
     
    ></LogDialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  GetInventoryList,
  InventoryExport,
} from "@/api/report/inventoryList.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import Toolbar from "../../components/Toolbar";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import OperateDialog from "../../components/TwTable/components/operateDialog";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getCustomerList } from "@/api/ProductSku.js";
import axios from "axios";
import { thereAre } from "util/util";
import {
  getInventoryDetailAsync,
  getBatchesInventoryAsync,
} from "../../api/api";
export default {
  components: { Toolbar, TwTable, OperateDialog, LogDialog },
  mixins: [TwTable_mixins],
  data() {
    return {
      activeName: "all",
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          width: "250",
          align: "center",
          options: [
            {
              name: "出入库明细",
              size: "mini",
              type: "text",
              event: "queryInOutDetails", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "sku",
            label: "SKU",
            align: "center",
            sortable: true,
             minWidth: "160",
          },
          {
            prop: "enableQty",
            label: "可用库存",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "onWayQty",
            label: "在途库存",
            align: "center",
            sortable: true,
             minWidth: "120",
          },
          {
            prop: "occupyQty",
            label: "占用库存",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
              {
            prop: "waitPutOnQty",
            label: "待上架库存",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "actualQty",
            label: "仓库库存",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "batchNum",
            label: "总批次",
            align: "center",
            minWidth: "120",
            slot:true,
            sortable: true,
          },

          {
            prop: "stockVolume",
            label: "在库库容",
            align: "center",
            sortable: true,
             minWidth: "120",
          },
        ],
      },
      InOutDetailTableData: [],
      batchesInventoryTableData:[],
      logListLoading:false,
      logListLoadingInOut:false,
      showLogInOut:false,
      showDialogInout:false,
    
      batchesInventoryListLoading:false,
      InOutDetailTableConfig: {
        title: "出入库明细库存",
        width:'70%',
        loading: true, // 显示loading状态
        showPage: true,
        column: [
           // 表格列配置
          {
            prop: "inventoryBatchIOLogID",
            label: "出入明细编号",
            align: "center",
            sortable: true,
            minWidth: "200",
          },

          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
          },
          {
            prop: "locationCode",
            label: "仓位",
            align: "center",
            sortable: true,
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
          },
          {
            prop: "sku",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "inventoryIOType",
            label: "出入库类型",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "batchCode",
            label: "批次号",
            align: "center",
            minWidth: "120",
            sortable: true,
           
          },

          {
            prop: "qty",
            label: "数量",
            align: "center",
            sortable: true,
          },

          {
            prop: "createTime",
            label: "过账时间",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "createUser",
            label: "过账用户",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
        ],
      },
      batchesInventoryTableConfig:{
         title: "批次明细库存",
         width:'80%',
         loading: false, // 显示loading状态
         showPage: true,
         column: [ {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
          },
          {
            prop: "locationCode",
            label: "仓位",
            align: "center",
            sortable: true,
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
          },
          {
            prop: "sku",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "batchCode",
            label: "批次号",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "createTime",
            label: "入库时间",
            align: "center",
            sortable: true,
          },
          {
            prop: "inQty",
            label: "入库数量",
            align: "center",
            sortable: true,
          },
          {
            prop: "outQty",
            label: "出库数量",
            align: "center",
            sortable: true,
          },
          {
            prop: "disableQty",
            label: "占用数量",
            align: "center",
            sortable: true,
          },
          {
            prop: "enableQty",
            label: "可用数量",
            align: "center",
            sortable: true,
          },
          {
            prop: "qty",
            label: "批次库存",
            align: "center",
            sortable: true,
          },
         ]
      },
      InOutDetailTablePageConfig: {
        pageIndex:1,
        pageSize:100,
      },
      InOutDetailTablePageParam:{
      
      },
      batchesInventoryPageConfig:{
         pageIndex:1,
        pageSize:100,
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "orgId",
            prop: "orgId",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.organizations,
          },
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.warehouses,
          },
          {
            type: "input",
            key: "prosku",
            label: "SKU",
            placeholder: "多个SKU用逗号分开查询",
            clearable: true,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
        
      },
      buttonList: [],

      //-------------
      filters: {
        CustomerId: "",
        WarehouseID: "",
        SKU: "",
      },
      organizations: [],
      warehouses: [],
      logPageConfiginOut: {        // 日志分页配置
          total: 0,
          pageIndex: 0,
          pageSize: 20,
          pageSizes: [10,20,50,100]
      },
    };
  },
  methods: {
    handleClick(tab, event) {
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
         this.newfilters =JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询列表
    initTable() {
      const { orgId, warehouseId, prosku } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        CustomerId: thereAre(orgId),
        WarehouseID: thereAre(warehouseId),
        SKU: prosku,
        stockType: this.activeName != 'all'? this.activeName == 'inStock' ? 1 : 2 :0
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetInventoryList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);

        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let InventoryProductIDs = "";
      row.forEach((item) => {
        InventoryProductIDs += item.inventoryProductID + ",";
      });
      if (InventoryProductIDs != null || InventoryProductIDs != "") {
        InventoryProductIDs = InventoryProductIDs.substring(
          0,
          InventoryProductIDs.lastIndexOf(",")
        );
      }
      const { orgId, warehouseId, prosku } = this.filters;
      let pata = {
        page: 0,
        pageSize: 60001,
        CustomerId: thereAre(orgId),
        WarehouseID: thereAre(warehouseId),
        SKU: prosku,
        stockType: this.activeName != 'all'? this.activeName == 'inStock' ? 1 : 2 :0,
        InventoryProductIDs: InventoryProductIDs,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: InventoryExport,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },


    batchesInventoryDetail(rows){
      
      this.currentRow = rows
      this.showLog = true;

      // const that = this;
      // this.isSelectRow(rows)
      //   .then((row) => {
      //      that.showLog = true;
      //          this.batchesInventoryTableConfig.loading = true;
        
     
      // let para = {
      //   page: 1,
      //   pageSize: 100,
      //   prosku:row.sku,
      //   warehouseId:row.warehouseID
      //  };
       
     
      //  getBatchesInventoryAsync(para).then((res) => {
      //   const { total, pageData, pageIndex, pageSize } = res.data.response;
      //    this.batchesInventoryTableConfig.loading = false;
      //   this.$set(this.batchesInventoryTableConfig, "total", total);
      //   this.$set(this.batchesInventoryTableConfig, "pageIndex", pageIndex);
      //   this.$set(this.batchesInventoryTableConfig, "pageSize", pageSize);
      //   this.batchesInventoryTableData = pageData;
      //  });
      //   })
      //   .catch((err) => {});

      
   
    },

    QueryPageInout(){

       getBatchesInventoryAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;
         this.batchesInventoryTableConfig.loading = false;
        this.$set(this.batchesInventoryTableConfig, "total", total);
        this.$set(this.batchesInventoryTableConfig, "page", pageIndex);
        this.$set(this.batchesInventoryTableConfig, "pageSize", pageSize);
        this.batchesInventoryTableData = pageData;
       });

    },
    queryInOutDetails(rows) {
      this.currentRow = rows
           this.showLogInOut = true;
      // const that = this;
      // this.isSelectRow(rows)
      //   .then((row) => {
      //     this.logListLoadingInOut = true;
      //      that.showLogInOut = true;
      //     // this.showDialogInout=true;
      //    this.InOutDetailTableData=[];
      //    this.InOutDetailTablePageConfig.showPage = false;
      // this.InOutDetailTablePageParam = {
      //   page: this.InOutDetailTablePageConfig.pageIndex,
      //   pageSize: this.InOutDetailTablePageConfig.pageSize,
      //   // prosku:row.sku,
      //   // warehouseId:row.warehouseID
      //  };
      

      //   getInventoryDetailAsync(this.InOutDetailTablePageParam).then((res) => {
      //   const { total, pageData, pageIndex, pageSize } = res.data.response;
      //  this.InOutDetailTableConfig.loading = false;
      //  this.InOutDetailTablePageConfig.showPage = true;
      //   this.$set(this.InOutDetailTablePageConfig, "total", total);
      //   this.$set(this.InOutDetailTablePageConfig, "page", pageIndex);
      //   this.$set(this.InOutDetailTablePageConfig, "pageSize", pageSize);
      //   this.InOutDetailTableData = pageData;
      //     this.logListLoadingInOut = false;

        
      //    });
      //   })
      //   .catch((err) => {});

      
        },
    
        // 日志关闭事件
        showDialogInOut() {
            this.showLogInOut = !this.showLogInOut
        },


         // 日志pageSize改变事件
        handleLogSizeChange(val) {
             this.InOutDetailTablePageParam.pageSize=val;
             this.$set(this.InOutDetailTablePageConfig,'pageSize',val)
             this.InOutDetailTableData = [];
              this.QueryPageInout();

            
        },
        handleLogCurrentChange(val){
         
            this.$set(this.InOutDetailTablePageConfig,'pageIndex',val)
            this.InOutDetailTablePageParam.page=val;
             this.InOutDetailTableData = [];
            this.QueryPageInout();

        },

         // 日志pageSize改变事件
        handleLogSizeChangeInOut(val) {
             this.InOutDetailTablePageParam.pageSize=val;
             this.$set(this.InOutDetailTablePageConfig,'pageSize',val)
             this.InOutDetailTableData = [];
              this.QueryPageInout();

            
        },
        handleLogCurrentChangeInOut(val){
         
            this.$set(this.InOutDetailTablePageConfig,'pageIndex',val)
            this.InOutDetailTablePageParam.page=val;
             this.InOutDetailTableData = [];
            this.QueryPageInout();

        },
        QueryPageInout(){

            this.logListLoadingInOut = true;
         getInventoryDetailAsync(this.InOutDetailTablePageParam).then((res) => {
            const { total, pageData, pageIndex, pageSize } = res.data.response;
          this.InOutDetailTableConfig.loading = false;
          this.InOutDetailTablePageConfig.showPage = true;
            this.$set(this.InOutDetailTablePageConfig, "total", total);
            this.$set(this.InOutDetailTablePageConfig, "page", pageIndex);
            this.$set(this.InOutDetailTablePageConfig, "pageSize", pageSize);
            this.InOutDetailTableData = pageData;
              this.logListLoadingInOut = false;

        
         });
        }
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    let para = {
      IsAll: true,
    };
    getCustomerList(para).then((res) => {
      this.organizations = res.data.response;
    });
  },
};
</script>

